
import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { startDeleteProducto, startListadoProductos, startProductosTodos, startProductoXID, startStockXProductos } from "../../../services";
import { useNavigate } from "react-router-dom";






export const useProductoXID = (id) => {
    const productoXIDQuery = useQuery({
        queryKey: ['producto-id', id], 
        queryFn: () => startProductoXID(id),
    });
    return { productoXIDQuery }
}



export const useProductosTodos = () => {
    const productosTodosQuery = useQuery({
        queryKey: ['producto-todos'], 
        queryFn: () => startProductosTodos(),
    });
    return { productosTodosQuery }
}



export const useStockProductoXId = (id) => {
    const { data, isLoading }  = useQuery({
        queryKey: ['stock-producto', id], 
        queryFn: () => startStockXProductos(id),
    });
    return { data, isLoading }
}




export const useProductosQuery = () => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');
    const productosListQuery = useQuery({
        queryKey: ['productos-list', { page, termino }], 
        queryFn: () => startListadoProductos({ page, termino }),
    });
    
    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }


    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        productosListQuery,
    }
}






export const useEliminarProducto = () => {

    const navigate = useNavigate();

    const mutationDeleteProducto = useMutation({
        mutationFn: (id) => startDeleteProducto(id),
        onSuccess: async(_, idEliminado) => {
            navigate(-1);
            // await queryClient.removeQueries(['producto', idEliminado]);
        },
    });

    return { mutationDeleteProducto }
}
